/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SubscriberBilling_account = {
    readonly subscriber: {
        readonly defaultMethod: {
            readonly brand: string;
            readonly expMonth: number;
            readonly billingName: string;
            readonly expYear: number;
            readonly last4: string;
        } | null;
        readonly currentInvoiceAmount: {
            readonly value: number;
            readonly currency: string;
        };
        readonly invoices: ReadonlyArray<{
            readonly id: string;
            readonly amountDue: number;
            readonly paid: boolean;
            readonly dueDate: string;
            readonly startDate: string;
            readonly endDate: string;
            readonly payURL: string;
            readonly pdfURL: string;
        } | null>;
    };
    readonly " $refType": "SubscriberBilling_account";
};
export type SubscriberBilling_account$data = SubscriberBilling_account;
export type SubscriberBilling_account$key = {
    readonly " $data"?: SubscriberBilling_account$data;
    readonly " $fragmentRefs": FragmentRefs<"SubscriberBilling_account">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubscriberBilling_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Subscriber",
      "kind": "LinkedField",
      "name": "subscriber",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentMethod",
          "kind": "LinkedField",
          "name": "defaultMethod",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "brand",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billingName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "last4",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Amount",
          "kind": "LinkedField",
          "name": "currentInvoiceAmount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Invoice",
          "kind": "LinkedField",
          "name": "invoices",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amountDue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dueDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "payURL",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pdfURL",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};
(node as any).hash = 'd268ad77a7ab8f411317c59cc5505c64';
export default node;
